import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { BackToPageDesktop, BackToPageMobile } from '../../components/BackToPage';
import { TBackBtnTexts } from './utils/getButtonTextByReferrer';
import { useFormTracking } from '../../utils/useFormTracking';
import { useButtonProps } from './utils/useButtonProps';
import { selectIsWebview } from '../../selectors/selectIsWebview';
import { useApplicationContext } from '../../utils/applicationContext';

export function BackToPageContainer() {
  const { config } = useApplicationContext();
  const backBtnTexts = config.get<TBackBtnTexts>('requestFormRealtor.backBtnTexts') || [];
  const isDesktop = useIsDesktop();
  const { trackBackToPage } = useFormTracking();
  const { href, text } = useButtonProps(backBtnTexts);
  const isWebview = useSelector(selectIsWebview);

  /**
   * Для вебвью никогда не показывает кнопку назад/крестик закрытия
   */
  if (!href || !text || isWebview) {
    return null;
  }

  const BackToPage = isDesktop ? BackToPageDesktop : BackToPageMobile;

  return <BackToPage text={text} href={href} onClick={trackBackToPage} />;
}
